import { render, staticRenderFns } from "./CombinedCurve.vue?vue&type=template&id=20b9351e&scoped=true&"
import script from "./CombinedCurve.vue?vue&type=script&lang=js&"
export * from "./CombinedCurve.vue?vue&type=script&lang=js&"
import style0 from "./CombinedCurve.vue?vue&type=style&index=0&id=20b9351e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9351e",
  null
  
)

export default component.exports